import React from 'react';
export var LayoutManagerContext = /*#__PURE__*/React.createContext(undefined);
LayoutManagerContext.displayName = 'LayoutManagerContext';
export default LayoutManagerContext;
//# sourceMappingURL=LayoutManagerContext.js.map